import { Injectable } from '@angular/core';
import { HttpClientWrapper } from './httpclientwrapper';
import { Observable, Subject } from 'rxjs';
import { IsAny, IsNotNull, IsNotNullOrEmpty, IsNotZeroNumber } from '@apply4u/shared/helpers/common/type-safe-helpers';
import { ShowHideLogs } from '@apply4u/Models/showHideLogs';
import { Job } from '@apply4u/models/search/job';
import { Candidate } from '@apply4u/models/search/candidate';
import { DashboardType } from '@apply4u/shared/enums';
import { ContextService } from './context-service';
import { ToasterMessageService } from './toaster-message.service';
import { LoadingService } from './loading.service';
import { ResultsWithOutPagination } from '@apply4u/models/search/results-with-out-pagination';
import { HiddenCv } from '@apply4u/Models/hidden-cvs';
import { HiddenJob } from '@apply4u/Models/hidden-jobs';
import { ShowHideLogsMessages } from '@apply4u/shared/constant/show-hide-logs';

@Injectable({
  providedIn: 'root'
})
export class ShowHideLogsService {

  public NotifyHideJob$ = new Subject<boolean>();
  public NotifyHideCV$ = new Subject<boolean>();
  public NotifyUnhideJob$ = new Subject<boolean>();
  public NotifyUnhideCV$ = new Subject<boolean>();

  constructor(private http: HttpClientWrapper,
    private ContextService: ContextService,
    private toasterService: ToasterMessageService,
    private loadingService: LoadingService) { }


  GetShowHideLogsById(Id: number): Observable<ShowHideLogs> {

    return this.http.GetAsync(this.http.BaseUrl + "api/ShowHideLogs/" + Id);
  }


  GetShowHideLogs(hiddenByUserId:number,candidateTypeId:number,jobId :number, candidateId:number
    , createdOn :Date,isActive :boolean,pageNumber:number, pageSize:number ): Observable<ShowHideLogs[]> {

    let requestParams = "?";

    if ( IsNotNull(hiddenByUserId) && hiddenByUserId > 0) {
     
      requestParams += "hiddenByUserId=" + hiddenByUserId;
    }

    if (IsNotNull(candidateTypeId) && candidateTypeId > 0) {

      requestParams += (requestParams == "?" ? "" : "&") + "candidateTypeId=" + candidateTypeId;
    }

    if (IsNotNull(jobId) && jobId > 0) {

      requestParams += (requestParams == "?" ? "" : "&") + "jobId=" + jobId;
    }

    if (IsNotNull(candidateId) && candidateId > 0) {

      requestParams += (requestParams == "?" ? "" : "&") + "candidateId=" + candidateId;
    }

    if (IsNotNull(createdOn)) {

      requestParams += (requestParams == "?" ? "" : "&") + "createdOn=" + createdOn;
    }

    if (IsNotNull(isActive) && isActive != false) {

      requestParams += (requestParams == "?" ? "" : "&") + "isActive=" + isActive;
    }

    if (pageNumber !== undefined && pageNumber != null && pageNumber != 0) {

      requestParams += (requestParams == "?" ? "" : "&") + "pageNumber=" + pageNumber;
    }

    if (pageSize !== undefined && pageSize != null && pageSize != 0) {

      requestParams += (requestParams == "?" ? "" : "&") + "pageSize=" + pageSize;
    }
    
    if (requestParams == "?") {

      requestParams = "";
    }

    return this.http.GetAsync<ShowHideLogs[]>(this.http.BaseUrl + "api/ShowHideLogs/search"+requestParams);
  }

  SaveHideJobInfo(job: Job){
    if (this.ContextService.IsUserLoggedIn == false) {
      this.toasterService.LoginMessageError();
      return;
    }

    let showHideLogs = new ShowHideLogs();
    showHideLogs.HiddenByUserId =  this.ContextService.LoggedInUserId;

    if (IsNotNull(job)) {
      showHideLogs.Id = 0;
      showHideLogs.CandidateTypeId = DashboardType.JobSeeker;
      showHideLogs.CandidateId = null;
      showHideLogs.JobId = job.Id;
      showHideLogs.CreatedOn = new Date();
      showHideLogs.IsActive = true;
    }

    // this.loadingService.Show();

    this.SaveShowHideLogsAsync(showHideLogs).subscribe({
      next: result => {
        this.NotifyHideJob$.next(true);
        this.loadingService.Hide();
        this.toasterService.Success(ShowHideLogsMessages.onJobHide);
      },
      error: error => {
        this.NotifyHideJob$.next(false);
        this.loadingService.Hide();
        this.toasterService.ServerError();
      }
    });

  }

  SaveHideCVInfo(candidate: Candidate){
    if (this.ContextService.IsUserLoggedIn == false) {
      this.toasterService.LoginMessageError();
      return;
    }

    let showHideLogs = new ShowHideLogs();
    showHideLogs.HiddenByUserId =  this.ContextService.LoggedInUserId;

    if (IsNotNull(candidate)) {
      showHideLogs.Id = 0;
      showHideLogs.CandidateTypeId = DashboardType.Recruiter;
      showHideLogs.CandidateId = candidate.Id;
      showHideLogs.JobId = null;
      showHideLogs.CreatedOn = new Date();
      showHideLogs.IsActive = true;
    }

    // this.loadingService.Show();

    this.SaveShowHideLogsAsync(showHideLogs).subscribe({
      next: result => {
        this.NotifyHideCV$.next(true);
        this.loadingService.Hide();
        this.toasterService.Success(ShowHideLogsMessages.onCVHide);
      },
      error: error => {
        this.NotifyHideCV$.next(false);
        this.loadingService.Hide();
        this.toasterService.ServerError();
      }
    });
  }

  SaveUnhideJobInfo(showHideLogId : number){
    if (this.ContextService.IsUserLoggedIn == false) {
      this.toasterService.LoginMessageError();
      return;
    }

    // this.loadingService.Show();

    this.DeleteShowHideLogs(showHideLogId).subscribe({
      next: result => {
        this.NotifyUnhideJob$.next(true);
        this.loadingService.Hide();
        this.toasterService.Success(ShowHideLogsMessages.onJobUnHide);
      },
      error: error => {
        this.NotifyUnhideJob$.next(false);
        this.loadingService.Hide();
        this.toasterService.ServerError();
      }
    });
  }

  SaveUnhideCVInfo(showHideLogId : number){
    if (this.ContextService.IsUserLoggedIn == false) {
      this.toasterService.LoginMessageError();
      return;
    }

    // this.loadingService.Show();
    
    this.DeleteShowHideLogs(showHideLogId).subscribe({
      next: result => {
        this.NotifyUnhideCV$.next(true);
        this.loadingService.Hide();
        this.toasterService.Success(ShowHideLogsMessages.onCVUnHide);
      },
      error: error => {
        this.NotifyUnhideCV$.next(false);
        this.loadingService.Hide();
        this.toasterService.ServerError();
      }
    });
  }

  SaveShowHideLogsAsync(showHideLogs : ShowHideLogs) :  Observable<ShowHideLogs>{
    return this.http.PostAsync(this.http.BaseUrl + "api/ShowHideLogs", showHideLogs);
  }

  UpdateShowHideLogs(id: number, showHideLogs: ShowHideLogs): Observable<any> {

    return this.http.PutAsync(this.http.BaseUrl + "api/ShowHideLogs/id?id=" + id, showHideLogs);
  }

  DeleteShowHideLogs(id: number): Observable<any> {

    return this.http.DeleteAsync(this.http.BaseUrl + "api/ShowHideLogs/id?id=" + id);
  }

  GetHiddenCVs(userId: number, pageNumber: number, pageSize: number): Observable<ResultsWithOutPagination<HiddenCv>> {
    return this.http.GetAsync<ResultsWithOutPagination<HiddenCv>>(this.http.BaseUrl + `api/ShowHideLogs/hiddenCvs?loggedInUserId=${userId}&pageNumber=${pageNumber}&pageSize=${pageSize}`);
  }

  GetHiddenJobs(userId: number, pageNumber: number, pageSize: number): Observable<ResultsWithOutPagination<HiddenJob>> {
    return this.http.GetAsync<ResultsWithOutPagination<HiddenJob>>(this.http.BaseUrl + `api/ShowHideLogs/hiddenJobs?loggedInUserId=${userId}&pageNumber=${pageNumber}&pageSize=${pageSize}`);
  }

}
